import paymentsConnectTypes from './paymentsConnectTypes'

export const initialState = {
  triumphPayUrl: '',
  triumphPayUrlError: '',
  triumphPayTokenGenerated: false,
  generateTriumphPayTokenError: '',
  loading: false
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case paymentsConnectTypes.GET_TRIUMPH_PAY_URL:
      return {
        ...state,
        triumphPayUrl: '',
        loading: true,
        triumphPayUrlError: ''
      }

    case paymentsConnectTypes.GET_TRIUMPH_PAY_URL_SUCCESS: {
      return {
        ...state,
        triumphPayUrl: payload,
        triumphPayUrlError: ''
      }
    }

    case paymentsConnectTypes.GET_TRIUMPH_PAY_URL_FAILURE: {
      return {
        ...state,
        loading: false,
        triumphPayUrlError: payload
      }
    }

    case paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN:
      return {
        ...state,
        loading: true,
        generateTriumphPayTokenError: ''
      }

    case paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN_SUCCESS: {
      return {
        ...state,
        triumphPayTokenGenerated: true,
        loading: false,
        generateTriumphPayTokenError: ''
      }
    }

    case paymentsConnectTypes.GENERATE_TRIUMPH_PAY_TOKEN_FAILURE: {
      return {
        ...state,
        loading: false,
        generateTriumphPayTokenError: payload
      }
    }

    default: return state
  }
}
